module.exports = __webpack_public_path__ + "img/lord.40da6b58.png";